export async function flushAndReloadApplication(reload = true) {
  await globalThis.noSqlDb?.clear?.();
  const cacheNames = await caches.keys();
  await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
  console.log('All caches cleared');
  if (reload) window.location.reload();
}

let handling409 = false;

export async function handleOutOfDateIntercept(reload = true) {
  if (handling409) return;
  if (globalThis.runningIsOutOfDate) return;
  handling409 = true;

  globalThis.runningIsOutOfDate = true;
  try {
    await flushAndReloadApplication(false);
    if (reload) {
      //this error came form a server response possibly so we need to force update our version info

      await globalThis.dealerRefreshApiDetails?.();
    }
  } finally {
    window.location.reload();
    handling409 = false;
  }
}
